module.exports = __webpack_public_path__ + "img/1528168044.c9c16c93.jpg";